<template>
    <a-modal
        centered
        :visible="visible"
        title="发起订单"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="840"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="order-create" :rules="rules">
            <a-row :gutter="32">
                <a-col :span="12">
                    <a-form-model-item label="合同名称" prop="contractName">
                        <a-input v-model="form.contractName"></a-input>
                    </a-form-model-item>

                    <a-form-model-item label="商标注册号" prop="brandNo">
                        <a-input v-model="form.brandNo"></a-input>
                    </a-form-model-item>

                    <a-form-model-item label="商标类目" prop="brandType">
                        <a-input v-model="form.brandType" placeholder="多个请用分号隔开"></a-input>
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="买家用户ID" prop="member_id">
                        <a-select
                            class="spotlight"
                            show-search
                            :show-arrow="false"
                            :dropdownMatchSelectWidth="false"
                            placeholder="快速搜索姓名、手机号码..."
                            :filter-option="false"
                            @search="on_membersearch"
                            style="transition:0.2s width"
                            option-label-prop="name"
                            v-model="form.member_id"
                        >
                            <a-spin v-if="loading_member" slot="notFoundContent" size="small" />

                            <a-select-opt-group v-for="d in data_member" :key="d.id">
                                <span slot="label">
                                    <a-icon type="user" />
                                    {{ d.name }}
                                </span>
                                <a-select-option :value="d.id" :key="d.id" :name="d.name" :item="d">
                                    <div>
                                        <a-icon type="mobile" />
                                        {{ d.mobile }}
                                    </div>
                                </a-select-option>
                            </a-select-opt-group>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="公证书份数" prop="notaryBookQty">
                        <a-select v-model="form.notaryBookQty">
                            <a-select-option value="1">1</a-select-option> <a-select-option value="2">2</a-select-option>
                            <a-select-option value="3">3</a-select-option>
                            <a-select-option value="4">4</a-select-option>
                            <a-select-option value="5">5</a-select-option>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row :gutter="32">
                <a-col :span="12">
                    <h1>转让方及其签约人信息</h1>
                    <a-form-model-item label="签约类别" prop="signerUnitClass">
                        <a-radio-group v-model="form.signerUnitClass" button-style="solid">
                            <a-radio-button :value="1">
                                个人
                            </a-radio-button>
                            <a-radio-button :value="2">
                                企业
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-model-item>

                    <template v-if="form.signerUnitClass == 2">
                        <a-form-model-item label="公司名称" prop="companyName">
                            <a-input v-model="form.companyName"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="公司地址" prop="companyAddress">
                            <a-input v-model="form.companyAddress"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="统一社会信用代码" prop="uniscid">
                            <a-input v-model="form.uniscid"></a-input>
                        </a-form-model-item>
                    </template>
                    <a-form-model-item label="签约人(法人)姓名" prop="signerName">
                        <a-input v-model="form.signerName"></a-input>
                    </a-form-model-item>
                    <a-form-model-item label="签约人(法人)手机" prop="signerCellPhone">
                        <a-input v-model="form.signerCellPhone"></a-input>
                    </a-form-model-item>

                    <a-form-model-item label="签约人(法人)住址" prop="signerAddress">
                        <a-input v-model="form.signerAddress"></a-input>
                    </a-form-model-item>
                    <template v-if="form.signerUnitClass == 1">
                        <a-form-model-item label="签约人(法人)身份证类型" prop="signerIdCardType">
                            <a-select v-model="form.signerIdCardType">
                                <a-select-option v-for="item in id_card_type" :key="item.value">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-model-item>

                        <a-form-model-item label="签约人(法人)身份证号码" prop="signerIdCardType">
                            <a-input v-model="form.signerIdCardNo"></a-input>
                        </a-form-model-item>
                    </template>
                </a-col>
                <a-col :span="12"
                    ><h1>接收方及其签约人信息</h1>
                    <a-form-model-item label="签约类别" prop="signerUnitClass2">
                        <a-radio-group v-model="form.signerUnitClass2" button-style="solid">
                            <a-radio-button :value="1">
                                个人
                            </a-radio-button>
                            <a-radio-button :value="2">
                                企业
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-model-item>
                    <template v-if="form.signerUnitClass2 == 2">
                        <a-form-model-item label="公司名称" prop="companyName2">
                            <a-input v-model="form.companyName2"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="统一社会信用代码" prop="uniscid2">
                            <a-input v-model="form.uniscid2"></a-input>
                        </a-form-model-item>
                    </template>
                    <template v-if="form.signerUnitClass2 == 1">
                        <a-form-model-item label="签约人(法人)姓名" prop="signerName2">
                            <a-input v-model="form.signerName2"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="身份证类型" prop="signerIdCardType2">
                            <a-select v-model="form.signerIdCardType2">
                                <a-select-option v-for="item in id_card_type" :key="item.value">{{ item.name }}</a-select-option>
                            </a-select>
                        </a-form-model-item>
                        <a-form-model-item label="身份证号码" prop="signerIdCardNo2">
                            <a-input v-model="form.signerIdCardNo2"></a-input>
                        </a-form-model-item>
                    </template>
                </a-col>
            </a-row>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        signerUnitClass2: 1,
        signerUnitClass: 1,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
        },
        data() {
            return {
                submitting: false,
                loading_member: false,
                data_member: [],
                data_trademark: null,
                data_user: [],
                id_card_type: [
                    {
                        name: "中华人民共和国居民身份证",
                        value: 10,
                    },
                    { name: "中华人民共和国军官证", value: 20 },
                    { name: "中华人民共和国警官证", value: 30 },
                    { name: "外国(地区)护照", value: 40 },
                    { name: "香港特别行政区护照", value: 51 },
                    { name: "香港(永久性)居民身份证", value: 52 },
                    { name: "澳门特别行政区护照", value: 53 },
                    { name: "澳门(永久性)居民身份证", value: 54 },
                    { name: "港澳居民来往内地通行证", value: 55 },
                    { name: "台湾居民身份证", value: 56 },
                    { name: "台湾居民来往大陆通行证", value: 57 },
                    { name: "台湾农民身份有关证明", value: 2058 },
                    { name: "户口薄", value: 60 },
                    { name: "其他有效身份证件", value: 90 },
                ],
                rules: {
                    contractName: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    member_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    brandNo: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    brandType: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    notaryBookQty: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
            // this.load_group();
            // this.load_role();

            this.get_users();
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_membersearch(v) {
                this.loading_member = true;
                this.$http
                    .get(`/member/accessible?type=plain&wd=${v}`)
                    .then((response) => {
                        if (response.success) {
                            this.data_member = response.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading_member = false;
                    });
            },
            get_users() {
                this.$http
                    .get(`/auth/user/accessible_by_as?as=order_trademark.generate`)
                    .then((response) => {
                        if (response.success) {
                            this.data_user = response.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            on_submit() {
                this.submitting = true;
                this.$http
                    .post("/notary", this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$message.success(res.message);
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
                this.$refs["order-create"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
            on_read_trademark() {
                let apply_no = this.form.apply_no;
                if (!apply_no) {
                    return false;
                }

                this.data_trademark = null;

                this.$http
                    .get("/trademark/" + apply_no)
                    .then((res) => {
                        if (res.success) {
                            this.data_trademark = res.data;
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
        },
    };
</script>
